import { call, takeLatest, put, select } from 'redux-saga/effects'
import { get } from 'lodash'
import api from '~/helpers/api'
import jsonToFormData from '~/helpers/jsonToFormData'
import { Types as CircularsTypes, Creators as CircularsActions } from '../ducks/circulars'
import { Creators as FlashMessageActions } from '../ducks/flashMessage'

const optionsSelector = ({ circulars }) => circulars.options

function* getActiveCirculars() {
  const options = yield select(optionsSelector)

  const search = []
  if (options.search) {
    search.push(`name,${options.search}`)
    search.push(`id,${options.search}`)
  }
  
  try {
    const { data } = yield call(api.get, 'circulars', {
      params: {
        'where[status]': 'active',
        search,
        page: options.page + 1,
        order: `${options.sort},${options.direction}`,
      },
    })

    yield put(CircularsActions.getCircularsSuccess(data.data, data.total))
  } catch (e) {
    yield put(CircularsActions.getCircularsFailure())
  }
}

function* getCirculars() {
  const options = yield select(optionsSelector)

  const search = []
  if (options.search) {
    search.push(`name,${options.search}`)
    search.push(`id,${options.search}`)
  }

  try {
    const { data } = yield call(api.get, 'circulars', {
      params: {
        search,
        page: options.page + 1,
        order: `${options.sort},${options.direction}`,
      },
    })

    yield put(CircularsActions.getCircularsSuccess(data.data, data.total))
  } catch (e) {
    yield put(CircularsActions.getCircularsFailure())
  }
}

function* getCircular({ id }) {
  try {
    const { data } = yield call(api.get, `circulars/${id}`)
    yield put(CircularsActions.getCircularSuccess(data))
  } catch (error) {
    yield put(CircularsActions.getCircularFailure())
    yield put(
      FlashMessageActions.showMessage({
        message: 'Ops! Algo deu errado. Tente novamente',
        variant: 'error',
      }),
    )
  }
}

function* reloadCirculars() {
  yield put(CircularsActions.getCircularsRequest())
}

function* removeCircular({ id, callback }) {
  try {
    yield call(api.delete, `/circulars/${id}`)

    yield put(CircularsActions.removeCircularFinish())
    yield put(
      FlashMessageActions.showMessage({
        message: 'Procedimento removido com sucesso!',
        variant: 'success',
      }),
    )
    if (callback) {
      yield call(callback)
    }
  } catch (e) {
    yield put(CircularsActions.removeCircularFinish())
    const error = get(e, 'response.data.error[0]')
    yield put(
      FlashMessageActions.showMessage({
        message: error || 'Ops! Algo deu errado. Tente novamente',
        variant: 'error',
      }),
    )
  }
}

function* addCircular({ data, callback }) {
  const formattedData = jsonToFormData(data)

  data.department_ids.map((item) =>
    formattedData.append('department_ids[]', String(item)),
  )

  try {
    yield call(api.post, 'circulars', formattedData)

    if (callback) {
      yield call(callback)
    }

    yield put(CircularsActions.addCircularSuccess())

    yield put(
      FlashMessageActions.showMessage({
        message: 'Procedimento cadastrado com sucesso!',
        variant: 'success',
      }),
    )
  } catch (e) {
    yield put(CircularsActions.addCircularFailure())
    const error = get(e, 'response.data.error[0]')
    yield put(
      FlashMessageActions.showMessage({
        message: error || 'Ops! Algo deu errado. Tente novamente',
        variant: 'error',
      }),
    )
  }
}

function* updateCircular({ id, data, callback }) {
  const formattedData = jsonToFormData(data)

  data.department_ids.map((item) =>
    formattedData.append('department_ids[]', String(item)),
  )

  try {
    yield call(api.post, `circulars/${id}`, formattedData)

    if (callback) {
      yield call(callback)
    }

    yield put(CircularsActions.updateCircularFinish())
    yield put(
      FlashMessageActions.showMessage({
        message: 'Circular editado com sucesso!',
        variant: 'success',
      }),
    )
  } catch (e) {
    yield put(CircularsActions.updateCircularFinish())
    const error = get(e, 'response.data.error[0]')
    yield put(
      FlashMessageActions.showMessage({
        message: error || 'Ops! Algo deu errado. Tente novamente',
        variant: 'error',
      }),
    )
  }
}

function* getAllDepartments() {
  try {
    const { data } = yield call(api.get, `departments`, {
      params: {
        pagination: 0,
        order: 'name,asc',
      },
    })

    yield put(CircularsActions.getAllDepartmentsSuccess(data))
  } catch (e) {
    yield put(CircularsActions.getAllDepartmentsFailure())
    const error = get(e, 'response.data.error[0]')
    yield put(
      FlashMessageActions.showMessage({
        message: error || 'Ops! Algo deu errado. Tente novamente',
        variant: 'error',
      }),
    )
  }
}

export default function* () {
  yield takeLatest(CircularsTypes.GET_ACTIVE_CIRCULARS_REQUEST, getActiveCirculars)
  yield takeLatest(CircularsTypes.GET_CIRCULARS_REQUEST, getCirculars)
  yield takeLatest(CircularsTypes.SET_CIRCULARS_SORT, reloadCirculars)
  yield takeLatest(CircularsTypes.SET_CIRCULARS_PAGE, reloadCirculars)
  yield takeLatest(CircularsTypes.GET_CIRCULAR_REQUEST, getCircular)
  yield takeLatest(CircularsTypes.REMOVE_CIRCULAR_REQUEST, removeCircular)
  yield takeLatest(CircularsTypes.ADD_CIRCULAR_REQUEST, addCircular)
  yield takeLatest(CircularsTypes.UPDATE_CIRCULAR_REQUEST, updateCircular)
  yield takeLatest(CircularsTypes.GET_ALL_DEPARTMENTS_REQUEST, getAllDepartments)
}
